import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import ShaderAnimation from './ShaderAnimation';
import { getRandomStringItem } from '../../utils';
import { gsap } from 'gsap';
import { AnimScene, randomAnimationDelayTime, randomAnimationSwitchTime, } from './animationUtils';
import LogoAnimation, { LogoAnimationState } from '../UI/LogoAnimation';
const logoSwitchDelay = 3.8;
const RandomShaderAnimation = ({ animations, isBespoke, animationState, close, refresh }) => {
    const defaultAnimState = isBespoke
        ? LogoAnimationState.PointsOutro
        : LogoAnimationState.None;
    // remove the firs animation item for start
    const animCollection = useRef(animations);
    const [anim, setAnim] = useState(animations[0]);
    const [isHidden, setIsHidden] = useState(true);
    const [isPaused, setIsPaused] = useState(!isBespoke);
    const [logoState, setLogoState] = useState(animationState ? animationState : defaultAnimState);
    const [showLogoAnimation, setShowLogoAnimation] = useState(isBespoke);
    const animRef = useRef(anim);
    animRef.current = anim;
    const animationStateRef = useRef(animationState);
    const delayedCallRef = useRef(null);
    const delayedSwitchRef = useRef(null);
    const delayedHideRef = useRef(null);
    const delayedPauseRef = useRef(null);
    const delayedLogosRef = useRef(null);
    const mounted = useRef(false);
    useEffect(() => {
        console.log('CLOSE Random Shader Animation');
    }, [close]);
    useEffect(() => {
        return () => {
            delayedCallRef.current?.kill();
            delayedSwitchRef.current?.kill();
            delayedHideRef.current?.kill();
            delayedLogosRef.current?.kill();
        };
    }, []);
    useEffect(() => {
        if (!isBespoke) {
            if (!isHidden) {
                onContinueAnimation();
            }
            else {
                onPauseAnimation();
            }
        }
    }, [isHidden]);
    const onContinueAnimation = () => {
        delayedPauseRef.current?.kill();
        setIsPaused(false);
    };
    const onPauseAnimation = () => {
        delayedPauseRef.current?.kill();
        delayedPauseRef.current = gsap.delayedCall(2, () => {
            setIsPaused(true);
        });
    };
    useEffect(() => {
        setLogoState(animationState ? animationState : defaultAnimState);
        if (!isBespoke) {
            if (animationState === LogoAnimationState.PointsOutro) {
                setIsHidden(false);
                setRandomAnim();
                onShowAnimation();
                startLogosAnimation(true);
            }
            else {
                setShowLogoAnimation(false);
                stopLogosAnimation();
                if (animationStateRef.current === LogoAnimationState.PointsOutro &&
                    animationState === LogoAnimationState.PointsIntro) {
                    delayedHideRef.current?.kill();
                    delayedHideRef.current = gsap.delayedCall(1, () => {
                        setIsHidden(true);
                    });
                }
                else {
                    setIsHidden(true);
                }
            }
        }
        animationStateRef.current = animationState;
    }, [animationState]);
    const waitForNextAnim = () => {
        delayedCallRef.current = gsap.delayedCall(randomAnimationDelayTime, onNewAnim);
    };
    const setRandomAnim = () => {
        const array = animCollection.current.length
            ? animCollection.current
            : animations.filter((item) => item !== animRef.current);
        const { item, arr } = getRandomStringItem(array);
        setAnim(item);
        animCollection.current = arr;
    };
    const onNewAnim = () => {
        setRandomAnim();
        if (mounted.current) {
            setShowLogoAnimation(false);
            setLogoState(LogoAnimationState.PointsIntro);
            delayedSwitchRef.current = gsap.delayedCall(randomAnimationSwitchTime + 0.7, applyNewAnim);
        }
        else {
            if (isBespoke) {
                waitForNextAnim();
            }
        }
        mounted.current = true;
    };
    const applyNewAnim = () => {
        setLogoState(LogoAnimationState.PointsOutro);
        waitForNextAnim();
        onShowAnimation();
    };
    const onShowAnimation = () => {
        gsap.delayedCall(0.27, () => setShowLogoAnimation(true));
    };
    if (!mounted.current && isBespoke) {
        onNewAnim();
    }
    const startLogosAnimation = (initial) => {
        delayedLogosRef.current?.kill();
        delayedLogosRef.current = gsap.delayedCall(logoSwitchDelay, onLogosAnimation);
    };
    const stopLogosAnimation = () => {
        delayedLogosRef.current?.kill();
    };
    const onLogosAnimation = () => {
        startLogosAnimation();
        setRandomAnim();
    };
    return (_jsxs(_Fragment, { children: [_jsx(ShaderAnimation, { paused: isPaused, iconMode: true, logoAnim: showLogoAnimation ? anim : AnimScene.ProteinPoints, eventsOnParent: true, hide: isBespoke ? undefined : isHidden }), _jsx(LogoAnimation, { state: logoState, eventsOnParent: true, isBespoke: isBespoke })] }));
};
export default RandomShaderAnimation;
